import { IProgramStructureWithGroupQuery } from 'app/library/program-item/interfaces/program-structure-with-default-execution.query.interface';
import { DefaultExecutionWithCourseOffering } from './default-execution-with-course-offering.model';
import { SimpleEntity } from 'app/projects/shared/src/lib/models/simple-entity.model';

// @dynamic
export class ProgramStructureWithGroup {
    group: SimpleEntity;
    structure: DefaultExecutionWithCourseOffering[];

    constructor(query: IProgramStructureWithGroupQuery) {
        if (query) {
            this.group = new SimpleEntity(query.group);
            this.structure = query.structure.map((structure) => new DefaultExecutionWithCourseOffering(structure));
        }
    }
}
